import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import TableContainer from "src/components/Common/TableContainer";
import { useNavigate } from "react-router";
import ModalValidation from "../Forms/FormValidation/unitsUsers/ModalValidation";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import useToast from "src/components/Common/toast";

const UnitsUsers = () => {
  document.title = "Orgãos de Estrutura de Membros - Khozi";
  const navigate = useNavigate();
  const [modal, setModal] = useState<boolean>(false);
  const [unitUsers, setUnitUsers] = useState<any>([]);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const { show, ToastComponent } = useToast();
  const [successDelete, setSuccessDelete] = useState(false);
  const [errorDelete, setErrorDelete] = useState(false);
  const [successUpdate, setSuccessUpdate] = useState(false);
  const [errorUpdate, setErrorUpdate] = useState(false);

  useEffect(() => {
    if (errorDelete) {
      show("Erro", "Erro ao apagar a orgão de estrutura do utilizador.");
      setErrorDelete(false);
    } else if (successDelete) {
      show("Sucesso", "Orgão de estrutura do utilizador apagada com sucesso.");
      setSuccessDelete(false);
    } else if (errorUpdate) {
      show("Erro", "Erro ao actualizar a orgão de estrutura do utilizador.");
      setErrorUpdate(false);
    } else if (successUpdate) {
      show(
        "Sucesso",
        "Orgão de estrutura do utilizador actualizada com sucesso."
      );
      setSuccessUpdate(false);
    }
  }, [successDelete, errorDelete, successUpdate, errorUpdate]);

  const unitsUsers = useSelector((state: any) => state.unitsUsers.unitsUsers);

  const toggle = () => {
    setModal(!modal);
  };

  const urlParams = new URLSearchParams(window.location.search);
  const userId = urlParams.get("user");
  const user = unitsUsers.find((u: any) => u.user === Number(userId));
  useEffect(() => {
    if (user) {
      setUnitUsers({
        id: user.id,
        user_id: user.user,
        user_name: `${user.first_name} ${user.last_name}`,
        level: user.level,
        unit_id: user.unidade,
        unity_name: user.unity_name,
        urlParam: true,
      });

      setIsEdit(true);
      toggle();
    }
  }, [user]);

  const handleRowClick = (arg: any) => {
    setUnitUsers({
      id: arg.id,
      user_id: arg.user,
      user_name: `${arg.first_name} ${arg.last_name}`,
      level: arg.level,
      unit_id: arg.unidade,
      unity_name: arg.unity_name,
    });
    setIsEdit(true);
    toggle();
  };

  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => {
          return <input type="checkbox" className="form-check-input" />;
        },
      },
      {
        Header: "Nome",
        accessor: (row: any) => `${row.first_name} ${row.last_name}`,
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Orgão de Estrutura",
        accessor: "unity_name",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Nível",
        accessor: "level",
        disableFilters: true,
        filterable: true,
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {ToastComponent}
          <Breadcrumbs
            title="Orgãos de Estrutura"
            breadcrumbItem="Orgãos de Estrutura de Membros"
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <TableContainer
                    addButtonLabel="Adicionar Membro a um Orgão"
                    columns={columns}
                    data={unitsUsers}
                    isGlobalFilter={true}
                    isAddUserList={true}
                    customPageSize={10}
                    className="custom-header-css"
                    handleUserClick={() => {
                      navigate("/units-users/create");
                    }}
                    handleRowClick={handleRowClick}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal isOpen={modal} toggle={toggle} centered={true}>
            <ModalHeader toggle={toggle} tag="h4">
              Editar Orgão de Estrutura de {unitUsers.user_name}
            </ModalHeader>
            <ModalBody>
              <ModalValidation
                selectedUnit={unitUsers}
                setModal={setModal}
                setSuccessDelete={setSuccessDelete}
                setErrorDelete={setErrorDelete}
                setSuccessUpdate={setSuccessUpdate}
                setErrorUpdate={setErrorUpdate}
              />
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UnitsUsers;
